/**
 * Supported DRM types.
 */
export enum MKDrmType {
    /**
     * ClearKey DRM.
     */
    ClearKey = "clearkey",

    /**
     * Widevine DRM.
     */
    Widevine = "widevine",

    /**
     * Playready DRM.
     */
    Playready = "playready",

    /**
     * Fairplay DRM.
     */
    Fairplay = "fairplay",

    /**
     * Unknown DRM.
     */
    Unknown = "unknown"
}